<template>
    <nav class="navbar">
        <div class="nav-content">
            <div class="nav-left">
                <TextButton buttonText="Logout" @click.prevent="handleLogout" />
            </div>
        </div>
    </nav>
</template>

<script>
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import TextButton from './TextButton.vue';
import ACTApiService from '../services/ACTApiService.js';

export default {
    name: 'NavBar',
    components: {
        TextButton
    },
    data() {
        return {
            actApiService: new ACTApiService()
        };
    },
    methods: {
        handleLogout() {
            const poolData = {
                UserPoolId: 'us-east-2_3novul0pN',
                ClientId: '51v76uda8o5l6niokhg852qnj5'
            };
            const userPool = new CognitoUserPool(poolData);
            const cognitoUser = userPool.getCurrentUser();
            
            if (cognitoUser) {
                cognitoUser.signOut();
            }
            
            this.actApiService.setAuthToken(null);
            sessionStorage.removeItem('actApiAuthToken');
            
            localStorage.removeItem('currentParticipantId');
            localStorage.removeItem('actGroupId');
            localStorage.removeItem('subjectId');
            localStorage.removeItem('biennialVisitTypeId');
            localStorage.removeItem('visitTypeId');
            localStorage.removeItem('selectedVisitType');
            localStorage.removeItem('visitId');
            
            localStorage.removeItem('clockDrawingLogId');
            localStorage.removeItem('trailMakingALogId');
            localStorage.removeItem('trailMakingBLogId');
            localStorage.removeItem('verbalFluencySupermarketLogId');
            localStorage.removeItem('verbalFluencyLetterFLogId');
            
            sessionStorage.removeItem("isLoggedIn");
            
            const keysToRemove = Object.keys(localStorage).filter(key => 
                key.includes('CognitoIdentityServiceProvider') || 
                key === 'LastAuthUser'
            );
            keysToRemove.forEach(key => localStorage.removeItem(key));
            
            this.$router.push("/login");
        }
    }
};
</script>

<style scoped>
.navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background-color: white;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.nav-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.nav-left {
    display: flex;
    align-items: center;
}
</style> 